import {
  FlexColumn,
  Radio,
  RadioGroup,
} from '@elementary/common-ui/components';
import useUserPreferences from '@elementary/common-ui/hooks/useUserPreferences';
import { Appearance } from '@elementary/common-ui/types';
import { fontWeight, space } from '@elementary/common-ui/style/utils';
import { FormControlLabel, InputLabel, Typography } from '@mui/material';
import SettingsSection from './SettingsSection';

const DEFAULT_APPEARANCE: Appearance = 'light';

const APPEARANCE_OPTIONS: { value: Appearance; label: string }[] = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'system', label: 'Match system' },
];

const Display = () => {
  const { userPreferences, updateUserPreferences } = useUserPreferences();

  const onAppearanceChange = (value: string) => {
    const option = APPEARANCE_OPTIONS.find((o) => o.value === value);
    if (option) {
      updateUserPreferences('appearance', option.value);
    }
  };

  return (
    <SettingsSection sx={{ gap: space('lg') }}>
      <Typography sx={{ fontWeight: fontWeight('semibold') }}>
        Display
      </Typography>
      <FlexColumn>
        <InputLabel shrink id="appearance-label">
          Appearance
        </InputLabel>
        <RadioGroup
          row
          aria-labelledby="appearance-label"
          value={userPreferences.appearance ?? DEFAULT_APPEARANCE}
          onChange={(_, value) => onAppearanceChange(value)}
          sx={{ gap: space('xxl') }}
        >
          {APPEARANCE_OPTIONS.map((o) => (
            <FormControlLabel
              key={o.value}
              value={o.value}
              control={<Radio sx={{ pl: 0 }} />}
              label={o.label}
              sx={{ m: 0 }}
            />
          ))}
        </RadioGroup>
      </FlexColumn>
    </SettingsSection>
  );
};

export default Display;
